<template>
  <div class="del-wrap">
    <el-dialog title="修改流量券"
               :visible="flowDialogVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               width="500px"
               center>
      <div>
        <el-select v-model="select"
                   style="width:20%"
                   slot="prepend"
                   placeholder="请选择">
          <el-option label="增加"
                     value="1"></el-option>
          <el-option label="减去"
                     value="0"></el-option>
        </el-select>
        <el-input-number style="width:80%"
                         :min="0"
                         :max="100"
                         :precision="0"
                         controls-position="right"
                         placeholder="请输入内容"
                         v-model="input"
                         class="input-with-select">
        </el-input-number>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="cancleDialog">取 消</el-button>
        <el-button type="primary"
                   @click="submitDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    flowDialogVisible: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      select: '1',
      input: 1
    }
  },
  methods: {
    cancleDialog () {
      this.$emit('cancleDialog', 'flowDialogVisible')
    },
    submitDialog () {
      this.$emit('submitFlowDialog', { amount: this.input, type: this.select })
    },
    clearData () {
      this.select = '1',
        this.input = 1
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  text-align: center;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.del-wrap /deep/ button.el-button.el-button--default {
  width: 85px;
  height: 32px;
}
.del-wrap /deep/ .el-input--suffix .el-input__inner {
  border-right: 1px solid #fff;
  border-radius: 4px 0 0 4px;
}
.del-wrap /deep/ .el-input-number.is-controls-right .el-input__inner {
  border-radius: 0 4px 4px 0;
}
</style>